import Pusher from 'pusher-js'
import { facilita } from '@/global'


export const websocketDeploymentImageModule = {
    namespaced: true,
    state: {
        pusher: null,
        channel: null,
        unityEvent: null
    },
    getters: {
        getPusher(state) {
            return state.pusher
        },
        getChannel(state) {
            return state.channel
        },
        getUnityEvent(state) {
            return state.unityEvent
        }
    },
    mutations: {
        SET_PUSHER(state) {
            state.pusher = new Pusher('b34088924a245727d19e', { cluster: 'mt1' })
        },
        SET_CHANNEL(state) {
            // Atribui o channel que é a instancia, para funcionar em desenvolvimento colocar aqui "suaempresa"
            state.channel = state.pusher.subscribe(facilita.instance)
        },
        SET_UNITY_EVENT(state, payload) {
            
            state.unityEvent = { ...payload }
        },
        CLEAR_UNITY_EVENT(state) {
            state.unityEvent = null
        },
        DISCONNECT_PUSHER(state) {
            if(state.pusher) {
                state.pusher.unsubscribe()
                state.pusher.disconnect()
                
                state.pusher = null
                state.channel = null
                state.unityEvent = null

            }
        }
    },
    actions: {
        /**
         * 
         * Método para inicializar o websocket com pusher
         */
        initializePusher({ commit, state }, channelName) {
            if (!state.pusher) {  // Apenas inicializa se o pusher não existir
                commit('SET_PUSHER');
                commit('SET_CHANNEL', channelName);
            }
        },
        /**
         * 
         * Método que vai ouvir o pusher
         */
        bindChannelEvent({ commit, state }, { eventName }) {
            if (state.channel) {
                state.channel.bind(eventName, function (rawData) {
    
                    // Emitir o evento para que o componente possa lidar com ele
                    commit('SET_UNITY_EVENT', rawData);
                });
            }
        },
        clearUnityEvent({ commit }) {
            commit('CLEAR_UNITY_EVENT');
        },
        disconnectPusher({ commit }) {
            commit('DISCONNECT_PUSHER');
        }
    }
}